import { FlexiToggle } from "appworks/graphics/elements/flexi-toggle";
import { Services } from "appworks/services/services";
import { slotModel } from "slotworks/model/slot-model";
import { Jurisdiction } from "slotworks/services/jurisdiction/jurisdiction-service";
import { ToggleControl } from "./toggle-control";

export class StopOnFeatureToggleControl extends ToggleControl {

    constructor(protected button: FlexiToggle) {
        super(button);

        const startingValue = slotModel.read().autoplay.stopOnFeatureWin;
        this.button.setValue(startingValue);

    }

    public setEnabled(enabled: boolean) {
        if (Services.jurisdiction.shouldStopAutoplayOnFeature()) {
            enabled = false;
        }

        this.button.setEnabled(enabled);

        super.setEnabled(enabled);
    }

    protected onChange(value: boolean): void {
        slotModel.write({ autoplay: { stopOnFeatureWin: value } });
    }
}
